module.exports = __webpack_public_path__ + "img/line.7003d7d5.svg";